import React, { Component } from "react";
import PrestamoService from "../../../../services/pagos/PrestamoService"
import { trackPromise } from 'react-promise-tracker';
import { formatoSeparadorMilesValue, separadorPuntoMiles, splitImporte } from '../../../generico/utils/FormatoInput'
import Popup from "react-popup";
import AuthService from "../../../../services/login/auth.service";
import $ from 'jquery';

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faFilePdf } from "@fortawesome/free-solid-svg-icons";
import PrestamoPreaprobadoService from '../../../../services/solicitudes/PrestamoPreaprobadoService';
import PrestamoInmediatoService from "../../../../services/solicitudes/PrestamoInmediatoService";

//// componentes reutilizables

export default class Paso3 extends Component {
  constructor(props) {
    super(props);
    this.state = this.getInitialState();
    const fechaActual = new Date();
    const fechaEn30Dias = new Date();
    fechaEn30Dias.setDate(fechaActual.getDate() + 30);
    const dia = fechaEn30Dias.getDate();
    const mes = fechaEn30Dias.getMonth() + 1;
    const year = fechaEn30Dias.getFullYear();
    this.fechaVencimientoPrimeraCuota = `${dia}/${mes}/${year}`;
    this.autorizador= sessionStorage.getItem("autorizador")
  }

  getInitialState = () => ({
    datosCuenta: [],
    idCredito: null
  })

  componentDidMount() {
  }

  getColumn() {
    return [
      {
        name: "concepto",
        selector: row => row.concepto,
      },
      {
        name: "valor",
        selector: row => row.valor,
      }]
  }

  obtenerDatos = (idPrestamo, cantCuotas, cuenta) => {

    trackPromise(
      PrestamoService.cuotasPagar(idPrestamo, "V", cantCuotas, cuenta)
        .then((response) => {
          var data = JSON.stringify(response.data);
          var jsonData = JSON.parse(data);
          // console.log(jsonData)
          if (jsonData.codRespuesta === "0") {

            var respuesta = [

              { concepto: "Capital + Interés:", valor: formatoSeparadorMilesValue(jsonData.detalleVerifica[0].capitalInteres) },
              { concepto: "Interés:", valor: formatoSeparadorMilesValue(jsonData.detalleVerifica[0].interesMora) },
              { concepto: "Otros Cargos:", valor: formatoSeparadorMilesValue(jsonData.detalleVerifica[0].otrosCargos) },
              { concepto: "Impuestos:", valor: formatoSeparadorMilesValue(jsonData.detalleVerifica[0].impuesto) },
              { concepto: "Total a Pagar:", valor: formatoSeparadorMilesValue(jsonData.detalleVerifica[0].totalAPagar) },
              { concepto: "Fecha de Operación:", valor: (new Date()).toLocaleDateString('es-ES', { year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric', second: 'numeric' }) }

            ];

            this.setState({ datosCuenta: respuesta });
          }
          else {
            $(".btn-cu-primary").attr("disabled", "true");
            Popup.queue(this.notifiPopup("Info", jsonData.codDescripcion));
            return;
          }
        }
        ).catch(function (error) {
          AuthService.logout()
          //console.log(error)
        }));
  }

  notifiPopup = (titulo, mensaje) =>
    Popup.register({
      title: titulo,
      content: mensaje,
      buttons: {
        right: [
          {
            text: "Aceptar",
            className: "success",
            action: function () {
              Popup.close();
            },
          },
        ],
      },
    });


  descargarSolicitud = async () => {
    await trackPromise(
      PrestamoPreaprobadoService.descagarSolicitudPrestamo()
        .then((response) => {
          var fileURL = URL.createObjectURL(response.data);
          window.open(fileURL, "");
        })
        .catch(function (error) {
          console.log(error);
        })
    );
  };

  descargarLiquidacion = async () => {
    await trackPromise(
      PrestamoPreaprobadoService.descagarSolicitudPrestamo()
        .then((response) => {
          var fileURL = URL.createObjectURL(response.data);
          window.open(fileURL, "");
        })
        .catch(function (error) {
          console.log(error);
        })
    );
  };


  descargar = async (tipoReporte) => {
    let data;
    if (tipoReporte === 'SOLICITUD') {
      data = {
        idSolicitud: this.props.idSolicitud,
        tipoReporte
      }
    }
    if (tipoReporte === 'LIQUIDACION') {
      data = {
        idCredito: this.props.idCredito,
        tipoReporte
      }
    }
    if (tipoReporte === 'AUTORIZADOR') {
      data = {
        idCredito: this.props.idCredito,
        tipoReporte
      }
    }
    await trackPromise(
      PrestamoInmediatoService.obtenerReporte(data)
        .then((response) => {
          console.log(response);
          var fileURL = URL.createObjectURL(response.data);
          window.open(fileURL, "");
        })
        .catch(function (error) {
          console.log(error);
        })
    );
  };


  render() {
    return (
      <div>
        <div className="row">
          <div className="steps clearfix">
            <ul role="tablist">
              <li role="tab" className="disabled">
                <span>
                  <div className="title">
                    <span className="title_text current">
                      Selección de Préstamo
                    </span>
                  </div>
                </span>
              </li>

              <li role="tab" >
                <span>
                  <div className="title">
                    <span className="title_text">
                      Liquidación de Préstamo
                    </span>

                  </div>
                </span>
              </li>
              <li role="tab" className="disabled current">
                <span>
                  <div className="title">
                    <span className="title_text">Confirmación</span>
                  </div>
                </span>
              </li>
            </ul>
          </div>
        </div>

        <hr />
        <div className="row ">

          <div className="col-md-12">
            <div className="row justify-content-md-center">
              <div className="col-lg-8 col-md-10">
                <p className="nro-operacion">
                  Número de Crédito: {this.props.idCredito}
                </p>
              </div>
            </div>
            <div className="row justify-content-md-center">
              <div className="col-8" style={{ marginBottom: 30 }}>
                <h5 className="item-vef" style={{ margin: 0 }}>
                  {AuthService.getSocio().nombreCompleto.trim()}

                </h5>
                <p className="" style={{ margin: 0 }}>
                  Tipo: Vista Normal

                </p>
                <p className="" style={{ margin: 0 }}>
                  Moneda: Gs.

                </p>

              </div>
            </div>
            <div className="row row justify-content-md-center">
              <div className="col-8">
                <div className="table-responsive">
                  <table className="table conf-prest-inm">
                    <tbody>

                      <tr>
                        <th>El monto total que solicitaste es:</th>
                        <td>{separadorPuntoMiles(this.props.importe)}  Gs.</td>
                      </tr>
                      <tr>
                        <th>Cantidad x importe de cuotas (capital + interés):</th>
                        <td>{this.props.plazo + " x " + separadorPuntoMiles(this.props.montoCuota)} Gs.</td>
                      </tr>


                      <tr>
                        <th>Vencimiento de la primera cuota:</th>
                        <td>{this.fechaVencimientoPrimeraCuota}</td>
                      </tr>
                      {this.props.mostrarObligaciones && <p className="titP3">Obligaciones Societarias</p>}

                      {splitImporte(this.state.depositoAporte) > 0 &&
                        <tr className="thSF">
                          <th className="thSF titMora">Deuda Aporte/Relacion Aporte:</th>
                          <td className="thSF">{this.state.depositoAporte} Gs.</td>
                        </tr>
                      }


                      {splitImporte(this.props.moraSolidaridad) > 0 &&
                        <tr>
                          <th className="titMora">Deuda Solidaridad:</th>
                          <td>{this.props.moraSolidaridad} Gs.</td>
                        </tr>
                      }
                      {splitImporte(this.props.moraAporteConyuge) > 0 &&
                        <tr>
                          <th className="titMora">Deuda Aporte Conyuge:</th>
                          <td>{this.props.moraAporteConyuge} Gs.</td>
                        </tr>
                      }
                      {splitImporte(this.props.moraSolidaridadConyuge) > 0 &&
                        <tr>
                          <th className="titMora">Deuda Solidaridad Conyuge:</th>
                          <td>{this.props.moraSolidaridadConyuge} Gs.</td>
                        </tr>
                      }

                      <tr>
                        <th>El importe neto a ser desembolsado es:</th>
                        <td>{separadorPuntoMiles(this.props.totalDesembolso)} Gs.</td>
                      </tr>
                      {this.props.cuentaDeposito &&
                        <tr>
                          <th>El monto se te desembolsó en la cuenta:</th>
                          <td>{this.props.cuentaDeposito}</td>
                        </tr>
                      }
                      <tr>
                        <th>Tasa de interés {separadorPuntoMiles(this.props.interes)} % nominal anual <br />
                        </th>

                        <td></td>
                      </tr>
                      <th className="thSF">Sistema de amortización francés</th>

                    </tbody>
                  </table>

                </div>
              </div>
            </div>
            <hr />

            <div className="row">
              
              <div className="col-lg-3 col-md-3 btn-consulta">
                <button
                  hidden
                  ref={(a) => (this.nextStep = a)}
                  onClick={this.props.firstStep}
                ></button>

              </div>
               {(this.autorizador==='S') && (
               <div className="col-lg-3 col-md-3">
                <button className="btn btn-cu-primary" onClick={() => { this.descargar('AUTORIZADOR') }}>
                  <FontAwesomeIcon icon={faFilePdf} />  Descargar Autorizador
                </button>
              </div>
               )}
              <div className="col-lg-3 col-md-3">
                <button className="btn btn-cu-primary" onClick={() => { this.descargar('LIQUIDACION') }}>
                  <FontAwesomeIcon icon={faFilePdf} />  Descargar Liquidación
                </button>
              </div>
              <div className="col-lg-3 col-md-3">
                <button className="btn btn-cu-primary" onClick={() => { this.descargar('SOLICITUD') }}>
                  <FontAwesomeIcon icon={faFilePdf} />  Descargar Solicitud
                </button>
              </div>
            </div>


          </div>

        </div>

      </div>
    );
  }
}